import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmModalComponent } from '../core/templates/confirm-modal.component';
import { ImageModalComponent} from '../core/templates/image-modal.component';
import { SimpleModalComponent } from '../core/templates/simple-modal.component';
import { ConfirmFormModalComponent } from '../core/templates/confirm-form-modal.component';

import {
  WMAIApiService,
  AuthService,
  RouterExtService,
  AppInformationService,
  GeolocationService,
  ExpLocalStorage,
} from './services';
@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    AuthService,
    WMAIApiService,
    RouterExtService,
    AppInformationService,
    GeolocationService,
    ExpLocalStorage
  ],
  entryComponents:[
    ConfirmModalComponent,
    ImageModalComponent,
    SimpleModalComponent,
    ConfirmFormModalComponent
  ],
  declarations: []
})
export class CoreModule { }
